export default __webpack_public_path__ + "static/media/belatra.13a0d58b.svg";